import { Helmet } from 'react-helmet-async';

const LocalBusinessSchema = () => {
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "SeniorThrive",
    url: "https://seniorthrive.com",
    logo: "https://seniorthrive.com/og-images/home.png",
    sameAs: [
      "https://seniorthrive.com"
    ]
  };

  const service = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "SeniorThrive Home Safety, Wellness, and Care Coordination Platform",
    serviceType: "Senior safety and wellness platform",
    provider: {
      "@type": "Organization",
      name: "SeniorThrive",
      url: "https://seniorthrive.com"
    },
    url: "https://seniorthrive.com",
    areaServed: {
      "@type": "Country",
      name: "United States"
    },
    audience: [
      { "@type": "Audience", audienceType: "Older adults" },
      { "@type": "Audience", audienceType: "Family caregivers" },
      { "@type": "Audience", audienceType: "Professional caregivers" },
      { "@type": "Audience", audienceType: "Care organizations" }
    ],
    offers: {
      "@type": "Offer",
      category: "FreeTrial",
      price: 0,
      priceCurrency: "USD",
      description: "7-day free trial of full SeniorThrive features"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
      <script type="application/ld+json">{JSON.stringify(service)}</script>
    </Helmet>
  );
};

export default LocalBusinessSchema;